var map = {
	"./about1.jpg": "679b",
	"./bittles1.jpg": "7965",
	"./bittles2.jpg": "229a",
	"./bittles3.jpg": "d83b",
	"./contactPage.jpg": "acfb",
	"./edited/four-straighten.jpg": "8efd",
	"./edited/four.jpg": "7bcd",
	"./edited/one.jpg": "c223",
	"./edited/three.jpg": "3113",
	"./edited/two.jpg": "66a9",
	"./example.jpg": "aa79",
	"./homeCol1.jpg": "71f0",
	"./homeCol2.jpg": "f1b6",
	"./homeCol3.jpg": "220c",
	"./homeCol4.jpg": "6cb8",
	"./logo.png": "9d64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";